module.exports = __webpack_public_path__ + "img/wide.764d3c5a.jpg";